//
// GeoInfo.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./GeoType";
import "./Lookup";
import "./AssociatedColumn";
import "./AssociatedRegion";

var GeoInfo = createModule("BIRD::GeoInfo", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        lookups: [1],
        geoType: 4,
        customCoordinateSpace: 7,
        associatedColumns: [1],
        associatedRegions: [1],
        regionMapProvider: 7,
        coordinateSpace: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default GeoInfo;
